import React from "react";
import { InputNumber } from "antd";

class IntegerInput extends React.Component {
  onChange = (value) => {
    // Eğer değer boş ise, boş bırak
    if (value === "" || value === null) {
      this.props.onChange(null);
    } else {
      // Sadece tam sayıları kabul et
      const integer = parseInt(value, 10);

      if (!isNaN(integer)) {
        this.props.onChange(integer);
      }
    }
  };

  // Formatter: Input değeri ekranda gösterilen değer
  formatter = (value) => {
    if (value === null || value === "") {
      return "";
    }
    return `${value}`.replace(/[^0-9]/g, "");
  };

  // Parser: Kullanıcının girdiği metni sayıya çevirme
  parser = (value) => {
    if (value === "") {
      return null;
    }
    return parseInt(value, 10);
  };
  render() {
    return (
      <InputNumber
        {...this.props}
        onChange={this.onChange}
        formatter={this.formatter}
        parser={this.parser}
        style={{ width: "100%" }}
      />
    );
  }
}

export default IntegerInput;
